import React, { useState, useContext, useEffect } from "react"
import Joi from "joi-browser"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import { injectIntl } from "react-intl"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Chevron from "./chevron.svg"
import Cookies from "universal-cookie"

import RefCodeGenerator from "../../utilities/refCodeGenerator"

import { PayURedirectModal, Button, ErrorModal } from ".."
import FormGroup from "@material-ui/core/FormGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import FormControl from "@material-ui/core/FormControl"
import FormHelperText from "@material-ui/core/FormHelperText"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import { CartContext, RichDescription, RichTitle } from ".."
import { Link } from "gatsby"
import withWidth from "@material-ui/core/withWidth"

import { Moltin } from "../../puraearth/src/services/Moltin"

import back from "../../images/back.svg"
import { CheckoutErrors } from "../"
import useLocalStorage from "../../hooks/useLocalStorage"
import moltinThreshold from "../../constants/moltinThreshold"

const useStyles = makeStyles(theme => {
  return {
    buttonRoot: {
      ...theme.typography.button,
      backgroundColor: theme.palette["green"].main,
      color: theme.palette["green"].contrastText,
      border: "1px solid " + theme.palette["green"].main,
      height: 48,
      padding: "0 20px",
      transition:
        "border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "&:hover": {
        border: "1px solid " + theme.palette["green"].light,
        backgroundColor: theme.palette["green"].light,
      },
      "&:disabled": {
        borderColor: theme.palette["black"].supportLight,
        backgroundColor: theme.palette["black"].supportLight,
        color: theme.palette["green"].contrastText,
      },
      "&:focus": {
        outline: "0",
      },
    },

    root: {
      backgroundColor: "#fff",
      [theme.breakpoints.up("lg")]: {
        width: "60vw",
      },
      [theme.breakpoints.down("md")]: {
        width: "100vw",
        padding: "0px 16px",
      },
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.up("lg")]: {
        marginLeft: theme.spacing(23),
        marginRight: theme.spacing(6),
        maxWidth: "624px",
      },
    },
    disabled: {
      background: "#f1f1f1",
    },
    groupContainer: {
      display: "flex",
      [theme.breakpoints.up("xl")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.down("lg")]: {
        flexDirection: "column",
      },
    },
    buttonStyling: {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      height: "100%",
      [theme.breakpoints.down("md")]: {
        marginLeft: theme.spacing(2),
      },
    },
    link: {
      textDecoration: "none",
      color: theme.palette.tertiary.main,
    },
    buttonSpacing: {
      maxWidth: "100vw",
      display: "flex",
      justifyContent: "space-between",
      paddingTop: "50px",
      [theme.breakpoints.down("md")]: {
        position: "fixed",
        bottom: "40px",
        left: "50%",
        backgroundColor: "#fff",
        height: "80px",
        width: "100vw",
        padding: "16px 16px",
        transform: "translate(-50%, 50%)",
        zIndex: 2,
      },
    },
    boxBorders: {
      border: "1px solid #8A8B8C",
      height: "48px",
      padding: "0 16px",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("xl")]: {
        marginRight: theme.spacing(6),
        width: "288px",
      },
      [theme.breakpoints.down("lg")]: {
        width: "100%",
      },
    },
    boxBordersDisabled: {
      height: "48px",
      padding: "0 16px",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("xl")]: {
        marginRight: theme.spacing(6),
        width: "288px",
      },
      [theme.breakpoints.down("lg")]: {
        width: "100%",
      },
    },
    firstBox: {
      [theme.breakpoints.up("lg")]: {
        marginRight: theme.spacing(6),
      },
    },
    boxBordersFullWidth: {
      border: "1px solid #8A8B8C",
      height: "48px",
      width: "100%",
      padding: theme.spacing(0, 2),
      marginBottom: theme.spacing(2),
    },

    logoImage: {
      position: "relative",
      width: theme.spacing(7.5),
      left: "50%",
      transform: "transkate(-50%)",
      paddingBottom: theme.spacing(1),
      [theme.breakpoints.up("lg")]: {
        marginTop: theme.spacing(7),
      },
      [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(1.625),
      },
    },
    formHelperText: {
      position: "absolute",
      top: theme.spacing(7.5),
    },
    paymentsContainer: {
      borderTop: "1px solid #f5f5f5",
      borderBottom: "1px solid #f5f5f5",
      marginTop: theme.spacing(7),
      height: "149px",
      padding: theme.spacing(3.125, 0),
      fontFamily: "Proxima Nova",
      fontSize: "16px",
    },
    footerTerms: {
      textDecoration: "none",
      color: "#231C1D",
      fontSize: "14px",
    },
    secondTerm: {
      textDecoration: "none",
      color: "#231C1D",
      marginLeft: theme.spacing(7),
      fontSize: "14px",
    },
    footerContainer: {
      display: "flex",
      justifyContent: "space-between",
      margin: theme.spacing(4, 0),
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "center",
        marginBottom: theme.spacing(10),
      },
    },
    payUStyle: {
      color: "#B7D100",
      fontFamily: "Proxima Nova",
      fontWeight: "bold",
    },
    inputMargin: {
      marginTop: theme.spacing(3.25),
    },
    formLabels: {
      fontFamily: "Proxima Nova",
      color: "#231C1D",
      fontSize: "16px",
      fontWeight: "600",
      letterSpacing: "1px",
      lineHeight: "1px",
      whiteSpace: "nowrap",
    },
    backChevron: {
      marginRight: theme.spacing(2),
      height: "22px",
      width: "22px",
    },
    paymentLogos: {
      marginLeft: theme.spacing(2),
      width: "54px",
      height: "38px",
      marginBottom: theme.spacing(1.625),
    },
    paymentLogosPayU: {
      width: "91px",
      height: "64px",
      marginTop: theme.spacing(1),
    },
    mobileButton: {
      [theme.breakpoints.up("lg")]: {
        display: "none",
      },
    },
    desktopButton: {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    desktopButtonShopping: {
      [theme.breakpoints.down("md")]: {
        maxWidth: "75px",
      },
    },
    brandPadding: {
      marginTop: theme.spacing(3),
    },
    footerBorderBox: {
      paddingBottom: theme.spacing(3),
      borderBottom: "1px solid #F5F5F5",
    },

    radio: {
      color: "#5B7F70",
      "&$checked": {
        color: "#5B7F70",
      },
    },
    ID: {
      display: "flex",
    },
    idText: {
      margin: theme.spacing(0, 0, 0, 2),
    },
    select: {
      marginTop: theme.spacing(2),
      borderColor: theme.palette.black.support,
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: 1,
      height: theme.spacing(6),
      width: theme.spacing(17),
      textAlign: "center",
      "&:focus": {
        backgroundColor: "transparent",
      },
      "&:active": { backgroundColor: "transparent" },
      padding: theme.spacing(0, 1, 0, 1),
    },
    arrow: {
      pointerEvents: "none",
      position: "absolute",
      right: theme.spacing(2),
    },
    selectRoot: {
      "&:focus": { backgroundColor: "transparent" },
    },
    checked: {},
    typography: {
      marginTop: theme.spacing(5),
    },
    subscribe: {
      marginTop: theme.spacing(2.5),
    },
    checkbox: {
      transform: "scale(1.3)",
      position: "relative",
      left: theme.spacing(0.2),
    },
    hiddenButton: {
      visibility: "hidden",
    },
    disabledEmailInput: {
      display: "none",
    },
  }
})

const GreenCheckbox = withStyles({
  root: {
    color: "#5B7F70",
    "&$checked": {
      color: "#5B7F70",
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />)

let refCodeGenerator
let signature
let currency
let amount

const ShippingInformation = props => {
  const Logo = props.header.mainLogo.file.url
  const visa = props.footer.visaLogo.file.url
  const payu = props.footer.payULogo.file.url
  const master = props.footer.masterCardLogo.file.url
  const amex = props.footer.amexLogo.file.url
  const discover = props.footer.discoverLogo.file.url
  const cookies = new Cookies()

  const classes = useStyles()
  let {
    createOrder,
    taxedSubtotalValue,
    siteCurrency,
    getShippingAddress,
    getSavedBillingAddress,
    setShippingAddress,
    setSavedBillingAddress,
  } = useContext(CartContext)

  // get and set the shipping and billing information
  useEffect(() => {
    const savedShippingAddress = getShippingAddress()

    if (savedShippingAddress) {
      setEmail(savedShippingAddress.email)
      setID(savedShippingAddress.instructions) // ID for colombian citizens
      setName(savedShippingAddress.first_name)
      setLastName(savedShippingAddress.last_name)
      setAddress(savedShippingAddress.line_1)
      setApartment(savedShippingAddress.line_2)
      setCity(savedShippingAddress.city)
      setCountry(savedShippingAddress.country)
      setProvince(savedShippingAddress.county)
      setPostalCode(savedShippingAddress.postcode)
      setPhone(savedShippingAddress.phone_number)
    }

    const savedBillingAddress = getSavedBillingAddress()

    if (savedBillingAddress) {
      setBillingAddress(savedBillingAddress.line_1)
      setBillingApartment(savedBillingAddress.line_2)
      setBillingCity(savedBillingAddress.city)
      setBillingCountry(savedBillingAddress.country)
      setBillingProvince(savedBillingAddress.county)
      setBillingPostalCode(savedBillingAddress.postcode)
    }
  }, [])
  const { locale } = props.intl
  const { access_token } = JSON.parse(localStorage.getItem("moltinCredentials"))

  // Shipping Form Values
  const [email, setEmail] = useState("")
  const [ID, setID] = useState("")
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [address, setAddress] = useState("")
  const [apartment, setApartment] = useState("")
  const [city, setCity] = useState("")
  const [country, setCountry] = useState("Colombia")
  const [province, setProvince] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [phone, setPhone] = useState("")
  const [order, setOrder] = useState({})
  const [idSelect, setIdSelect] = React.useState("C.C.")

  const [check, setCheck] = useState(true)
  const [open, setOpen] = useState(false)
  const [openOOSO, setOutOfStockOpen] = useState(false)
  const [useShippingAsBilling, setUseShippingAsBilling] = useState(true)
  const [errorOpen, setErrorOpen] = useState(false)

  const [billingAddress, setBillingAddress] = useState("")
  const [billingApartment, setBillingApartment] = useState("")
  const [billingCity, setBillingCity] = useState("")
  const [billingCountry, setBillingCountry] = useState("Colombia")
  const [billingProvince, setBillingProvince] = useState("")
  const [billingPostalCode, setBillingPostalCode] = useState("")

  const [cartId, setCartId] = useLocalStorage("mcart", null)

  const formObject = useShippingAsBilling
    ? {
      email,
      ID,
      name,
      lastName,
      address,
      city,
      country,
      province,
      postalCode,
    }
    : {
      email,
      ID,
      name,
      lastName,
      address,
      city,
      country,
      province,
      postalCode,
      billingAddress,
      // billingCountry,
      billingProvince,
      billingPostalCode,
    }

  const schema = useShippingAsBilling
    ? {
      email: Joi.string()
        .email()
        .required(),
      ID: Joi.string().required(),
      name: Joi.string().required(),
      lastName: Joi.string().required(),
      address: Joi.string().required(),
      city: Joi.string().required(),
      country: Joi.string().required(),
      province: Joi.string().required(),
      postalCode: Joi.string().required(),
    }
    : {
      email: Joi.string()
        .email()
        .required(),
      ID: Joi.string().required(),
      name: Joi.string().required(),
      lastName: Joi.string().required(),
      address: Joi.string().required(),
      city: Joi.string().required(),
      country: Joi.string().required(),
      province: Joi.string().required(),
      postalCode: Joi.string().required(),
      billingAddress: Joi.string().required(),
      // billingCountry: Joi.string().required(),
      billingProvince: Joi.string().required(),
      billingPostalCode: Joi.string().required(),
    }

  const validate = () => {
    let error = Joi.validate(formObject, schema, { abortEarly: false })
    error = error || {}
    return error.error ? true : false
  }

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value }
    const schemaProperty = { [name]: schema[name] }
    let error = Joi.validate(obj, schemaProperty)
    error = error || {}
    return error.error ? true : false
  }

  // Shipping Form Errors
  const [emailError, setEmailError] = useState(false)
  const [IDError, setIDError] = useState(false)
  const [nameError, setNameError] = useState(false)
  const [lastNameError, setLastNameError] = useState(false)
  const [addressError, setAddressError] = useState(false)
  // const [apartmentError, setApartmentError] = useState(false)
  const [cityError, setCityError] = useState(false)
  const [countryError, setCountryError] = useState(false)
  const [provinceError, setProvinceError] = useState(false)
  const [postalCodeError, setPostalCodeError] = useState(false)

  // Billing form errors
  const [billingAddressError, setBillingAddressError] = useState(false)
  // const [billingApartmentError, setBillingApartmentError] = useState(false)
  const [billingCityError, setBillingCityError] = useState(false)
  // const [billingCountryError, setBillingCountryError] = useState(false)
  const [billingProvinceError, setBillingProvinceError] = useState(false)
  const [billingPostalCodeError, setBillingPostalCodeError] = useState(false)

  const emailValidation = value => {
    const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(value) ? false : true
  }

  const stringValidation = value => {
    return !value ? true : false
  }

  const handleSelectChange = event => {
    setIdSelect(event.target.value)
  }

  const iconComponent = () => (
    <img src={Chevron} alt={""} className={classes.arrow}/>
  )

  const handleChange = event => {
    setCheck(!check)
  }

  const handleRadioChange = event => {
    setUseShippingAsBilling(!useShippingAsBilling)
  }

  // Shipping address handlers
  const handleNameChange = event => {
    setName(event.target.value)
    const error = validateProperty(event.target)
    setNameError(error)
  }

  const handleLastNameChange = event => {
    setLastName(event.target.value)
    const error = validateProperty(event.target)
    setLastNameError(error)
  }

  const handleAddressChange = event => {
    setAddress(event.target.value)
    const error = validateProperty(event.target)
    setAddressError(error)
  }

  const handleApartmentChange = event => {
    setApartment(event.target.value)
  }

  const handleCityChange = event => {
    setCity(event.target.value)
    const error = validateProperty(event.target)
    setCityError(error)
  }

  const handleCountryChange = event => {
    // Set hard-coded value for now, do not allow it to change.
    setCountry("Colombia")
  }

  const handleProvinceChange = event => {
    setProvince(event.target.value)
    const error = validateProperty(event.target)
    setProvinceError(error)
  }

  const handlePostalCodeChange = event => {
    setPostalCode(event.target.value)
    const error = validateProperty(event.target)
    setPostalCodeError(error)
  }

  const handlePhoneChange = event => {
    setPhone(event.target.value)
  }

  const handleEmailChange = event => {
    const value = event.target.value
    setEmail(value)
    cookies.set("emailAddress", value, { path: "/" })
  }

  const handleIDChange = event => {
    const value = event.target.value
    setID(value)
  }

  // Billing address handlers

  const handleBillingAddressChange = event => {
    setBillingAddress(event.target.value)
  }

  const handleBillingApartmentChange = event => {
    setBillingApartment(event.target.value)
  }

  const handleBillingCityChange = event => {
    setBillingCity(event.target.value)
  }

  const handleBillingCountryChange = event => {
    // Set hard-coded value for now, do not allow it to change.
    setBillingCountry("Colombia")
  }

  const handleBillingProvinceChange = event => {
    setBillingProvince(event.target.value)
  }

  const handleBillingPostalCodeChange = event => {
    setBillingPostalCode(event.target.value)
  }

  function processProduct(cart, i, maxInventoryNum, callback) {
    if (cart.data[i]) {
      let item = cart.data[i]
      if (item.type === "cart_item") {
        let productID = item.product_id
        Moltin.Products.Get(productID).then(product => {
          if (product.data.inventory <= maxInventoryNum) {
            setOutOfStockOpen(true)
            callback(false)
            return
          } else {
            return processProduct(cart, ++i, maxInventoryNum, callback)
          }
        })
      } else {
        return processProduct(cart, ++i, maxInventoryNum, callback)
      }
    } else {
      setOutOfStockOpen(false)
      callback(true)
    }
  }

  function checkProductAvailability(callback) {
    Moltin.Cart(cartId)
      .Items()
      .then(cart => {
        let status = false
        let maxInventoryNum = parseInt(moltinThreshold.thresholdValue)
        processProduct(cart, 0, maxInventoryNum, callback)
      })
  }

  const handleSubmit = () => {
    checkProductAvailability(function(status) {
      if (status) {
        setEmailError(emailValidation(email))
        setIDError(stringValidation(ID))
        setNameError(stringValidation(name))
        setLastNameError(stringValidation(lastName))
        setAddressError(stringValidation(address))
        setCityError(stringValidation(city))
        setCountryError(stringValidation(country))
        setProvinceError(stringValidation(province))
        setPostalCodeError(stringValidation(postalCode))

        // setOpen(true)

        const shippingMoltinAddress = {
          first_name: name,
          last_name: lastName,
          line_1: address,
          line_2: apartment,
          county: province,
          city: city,
          postcode: postalCode,
          country: country,
          phone_number: phone,
          instructions: ID,
        }

        const billingMoltinAddress = {
          first_name: name,
          last_name: lastName,
          line_1: billingAddress,
          line_2: billingApartment,
          county: billingProvince,
          city: billingCity,
          postcode: billingPostalCode,
          country: billingCountry,
          phone_number: phone,
        }

        localStorage.setItem("payULocale", locale)

        refCodeGenerator = RefCodeGenerator(email)
        currency = siteCurrency
        amount = (taxedSubtotalValue / 100).toFixed(2)
        let SHA256 = require("crypto-js/sha256")

        let message = `13076074172~71746~${refCodeGenerator}~${amount}~${currency}`
        signature = SHA256(message).toString()

        const customer = {
          email: email,
          name: name + lastName,
        }

        if (
          !(
            emailError ||
            IDError ||
            nameError ||
            lastNameError ||
            addressError ||
            cityError ||
            countryError ||
            provinceError ||
            postalCodeError
          )
        ) {
          const data = {
            case: 1,
            email: email,
          }
          fetch(
            "https://55mdpi5wl2.execute-api.sa-east-1.amazonaws.com/prod/moltin_cart_calls",
            {
              method: "post",
              body: JSON.stringify(data),
            },
          )
            .catch(error => {
              console.log(error)
              setErrorOpen(true)
              return new Promise((resolve, reject) => reject())
            })
            .then(() =>
              createOrder(
                customer,
                useShippingAsBilling
                  ? shippingMoltinAddress
                  : billingMoltinAddress,
                shippingMoltinAddress,
                props.langKey,
              )
                .then(result => {
                  setOrder(result)
                  setOpen(true)
                })
                .then(() =>
                  setTimeout(() => {
                    props.reference.current.click()
                  }, 1000),
                )
                .catch(error => {
                  console.log(error)
                  setErrorOpen(true)
                  return
                }),
            )
        }
      }
    })
  }

  const hideOOSO = () => {
    setOutOfStockOpen(false)
  }

  const { intl } = props
  const i18nmessages = intl.messages

  //onclick function for continue shopping (local storage)
  const saveShippingInformation = () => {
    const shippingMoltinAddress = {
      email,
      first_name: name,
      last_name: lastName,
      line_1: address,
      line_2: apartment,
      county: province,
      city: city,
      postcode: postalCode,
      country: country,
      phone_number: phone,
      instructions: ID,
    }
    setShippingAddress(shippingMoltinAddress)

    const billingMoltinAddress = {
      line_1: billingAddress,
      line_2: billingApartment,
      county: billingProvince,
      city: billingCity,
      postcode: billingPostalCode,
      country: billingCountry,
    }
    setSavedBillingAddress(billingMoltinAddress)
  }

  return (
    <div className={classes.root}>
      {!errorOpen && (
        <PayURedirectModal
          open={open}
          bgImgLeft={props.bgImgLeft}
          bgImgRight={props.bgImgRight}
          payULogo={payu}
        />
      )}
      {errorOpen && (
        <ErrorModal bgImgLeft={props.bgImgLeft} bgImgRight={props.bgImgRight}/>
      )}
      <CheckoutErrors
        open={openOOSO}
        bgImgLeft={props.bgImgLeft}
        bgImgRight={props.bgImgRight}
        handleHide={hideOOSO}
        i18nmessages={i18nmessages}
      />
      <div className={classes.formContainer}>
        {props.width === "lg" || props.width === "xl" ? (
          <Link to={`/${props.langKey}`}>
            <div justify="center">
              <img
                className={classes.logoImage}
                src={Logo}
                data-cy="header-logo"
                alt="Logo"
              />
            </div>
          </Link>
        ) : null}

        {!props.showCart && (
          <div>
            <Typography variant={"h4"} className={classes.typography}>
              {props.checkout.pageTitle && (
                <RichTitle titleText={props.checkout.pageTitle}/>
              )}
            </Typography>

            <FormControl
              className={`${classes.formControl}, ${classes.inputMargin}`}
              error={emailError}
              fullWidth={props.width === "xl" ? false : true}
            >
              <InputLabel
                className={classes.formLabels}
                shrink={true}
                htmlFor={"component-error"}
              >
                {props.checkout.emailAddressTitle && (
                  <RichTitle titleText={props.checkout.emailAddressTitle}/>
                )}
              </InputLabel>
              <Input
                onBlur={() => {
                  setEmailError(emailValidation(email))
                }}
                className={`${classes.formControl} ${classes.boxBorders}`}
                id="component-error"
                value={email}
                onChange={handleEmailChange}
                aria-describedby="component-error-text"
                error={emailError}
                name="email"
              />
              {emailError && (
                <FormHelperText
                  className={classes.formHelperText}
                  id="component-error-text"
                >
                  {i18nmessages.enterValidEmail}
                </FormHelperText>
              )}
            </FormControl>

            <FormGroup row className={classes.subscribe}>
              <FormControlLabel
                control={
                  <GreenCheckbox
                    checked={check}
                    onChange={handleChange}
                    value={check}
                    className={classes.checkbox}
                  />
                }
                label={props.checkout.receiveUpdatesText.receiveUpdatesText}
              />
            </FormGroup>
            <FormControl
              className={`${classes.formControl} ${classes.inputMargin}`}
              error={IDError}
              fullWidth
            >
              <div className={classes.ID}>
                <Select
                  labelId="demo-simple-select-error-label"
                  id="demo-simple-select-error"
                  value={idSelect}
                  onChange={handleSelectChange}
                  renderValue={value => `${value}`}
                  className={classes.select}
                  IconComponent={iconComponent}
                  classes={{
                    root: classes.selectRoot,
                  }}
                >
                  <MenuItem value={"C.C."}>{i18nmessages.CC}</MenuItem>
                  <MenuItem value={"C.E."}>{i18nmessages.CE}</MenuItem>
                  <MenuItem value={"NIT"}>{i18nmessages.NIT}</MenuItem>
                  <MenuItem value={i18nmessages.passport}>
                    {i18nmessages.passport}
                  </MenuItem>
                  <MenuItem value={i18nmessages.other}>
                    {i18nmessages.other}
                  </MenuItem>
                </Select>
                <InputLabel
                  className={classes.formLabels}
                  shrink={true}
                  htmlFor={"component-error"}
                >
                  {props.checkout.identificationTitle && (
                    <RichTitle titleText={props.checkout.identificationTitle}/>
                  )}
                </InputLabel>
                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "ID",
                      value: ID,
                    })
                    setIDError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBordersFullWidth} ${classes.idText}`}
                  id="component-error"
                  value={ID}
                  onChange={handleIDChange}
                  aria-describedby="component-error-text"
                  name="ID"
                />
                {IDError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterID}
                  </FormHelperText>
                )}
              </div>
            </FormControl>
            <Typography variant={"h4"} className={classes.typography}>
              {i18nmessages.shippingAddress}
            </Typography>
            <div className={classes.groupContainer}>
              <FormControl
                className={`${classes.formControl} ${classes.firstBox} ${classes.inputMargin}`}
                error={nameError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  className={classes.formLabels}
                  shrink={true}
                  htmlFor={"component-error"}
                >
                  {props.checkout.firstNameTitle && (
                    <RichTitle titleText={props.checkout.firstNameTitle}/>
                  )}
                </InputLabel>
                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "name",
                      value: name,
                    })
                    setNameError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBorders}`}
                  id="component-error"
                  value={name}
                  onChange={handleNameChange}
                  aria-describedby="component-error-text"
                  name="name"
                />
                {nameError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterFirstName}
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl
                className={`${classes.formControl} ${classes.textBoxContainers} ${classes.inputMargin}`}
                error={lastNameError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  shrink={true}
                  className={`${classes.textBoxContainers} ${classes.formLabels}`}
                  htmlFor={"component-error"}
                >
                  {props.checkout.lastNameTitle && (
                    <RichTitle titleText={props.checkout.lastNameTitle}/>
                  )}
                </InputLabel>

                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "lastName",
                      value: lastName,
                    })
                    setLastNameError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBorders}`}
                  id="component-error"
                  value={lastName}
                  onChange={handleLastNameChange}
                  aria-describedby="component-error-text"
                  name="lastName"
                />
                {lastNameError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterLastName}
                  </FormHelperText>
                )}
              </FormControl>
            </div>

            <FormControl
              className={`${classes.formControl} ${classes.inputMargin}`}
              error={addressError}
              fullWidth
            >
              <InputLabel
                className={classes.formLabels}
                shrink={true}
                htmlFor={"component-error"}
              >
                {props.checkout.addressTitle && (
                  <RichTitle titleText={props.checkout.addressTitle}/>
                )}
              </InputLabel>
              <Input
                onBlur={() => {
                  const error = validateProperty({
                    name: "address",
                    value: address,
                  })
                  setAddressError(error)
                }}
                className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                id="component-error"
                value={address}
                onChange={handleAddressChange}
                aria-describedby="component-error-text"
                name="address"
              />
              {addressError && (
                <FormHelperText
                  className={classes.formHelperText}
                  id="component-error-text"
                >
                  {i18nmessages.enterAddress}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              className={`${classes.formControl} ${classes.inputMargin}`}
              // error={apartmentError}
              fullWidth
            >
              <InputLabel
                className={classes.formLabels}
                shrink={true}
                htmlFor={"component-error"}
              >
                {props.checkout.apartmentTitle && (
                  <RichTitle titleText={props.checkout.apartmentTitle}/>
                )}
              </InputLabel>
              <Input
                className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                id="component-error"
                value={apartment}
                onChange={handleApartmentChange}
                aria-describedby="component-error-text"
                name="apartment"
              />
            </FormControl>

            <div className={classes.groupContainer}>
              <FormControl
                className={`${classes.formControl} ${classes.firstBox}  ${classes.inputMargin}`}
                error={cityError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  className={classes.formLabels}
                  shrink={true}
                  htmlFor={"component-error"}
                >
                  {props.checkout.cityTitle && (
                    <RichTitle titleText={props.checkout.cityTitle}/>
                  )}
                </InputLabel>
                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "city",
                      value: city,
                    })
                    setCityError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBorders}`}
                  id="component-error"
                  value={city}
                  onChange={handleCityChange}
                  aria-describedby="component-error-text"
                  name="city"
                />
                {cityError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterCity}
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl
                className={`${classes.formControl} ${classes.textBoxContainers}  ${classes.inputMargin}`}
                error={countryError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  className={`${classes.textBoxContainers} ${classes.formLabels}`}
                  htmlFor={"component-error"}
                  shrink={true}
                >
                  {props.checkout.countryTitle && (
                    <RichTitle titleText={props.checkout.countryTitle}/>
                  )}
                </InputLabel>

                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "country",
                      value: country,
                    })
                    setCountryError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBordersDisabled} ${classes.disabled}`}
                  id="component-error"
                  value={country}
                  onChange={handleCountryChange}
                  aria-describedby="component-error-text"
                  disabled={true}
                  name="country"
                />
                {countryError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterCountryRegion}
                  </FormHelperText>
                )}
              </FormControl>
            </div>

            <div className={classes.groupContainer}>
              <FormControl
                className={`${classes.formControl} ${classes.firstBox}  ${classes.inputMargin}`}
                error={provinceError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  className={classes.formLabels}
                  shrink={true}
                  htmlFor={"component-error"}
                >
                  {props.checkout.provinceTitle && (
                    <RichTitle titleText={props.checkout.provinceTitle}/>
                  )}
                </InputLabel>
                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "province",
                      value: province,
                    })
                    setProvinceError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBorders}`}
                  id="component-error"
                  value={province}
                  onChange={handleProvinceChange}
                  aria-describedby="component-error-text"
                  name="province"
                />
                {provinceError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterProvince}
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl
                className={`${classes.formControl} ${classes.textBoxContainers}  ${classes.inputMargin}`}
                error={postalCodeError}
                fullWidth={props.width === "xl" ? false : true}
              >
                <InputLabel
                  className={`${classes.textBoxContainers} ${classes.formLabels}`}
                  htmlFor={"component-error"}
                  shrink={true}
                >
                  {props.checkout.postalCodeTitle && (
                    <RichTitle titleText={props.checkout.postalCodeTitle}/>
                  )}
                </InputLabel>

                <Input
                  onBlur={() => {
                    const error = validateProperty({
                      name: "postalCode",
                      value: postalCode,
                    })
                    setPostalCodeError(error)
                  }}
                  className={`${classes.formControl} ${classes.boxBorders}`}
                  id="component-error"
                  value={postalCode}
                  onChange={handlePostalCodeChange}
                  aria-describedby="component-error-text"
                  name="postalCode"
                />
                {postalCodeError && (
                  <FormHelperText
                    className={classes.formHelperText}
                    id="component-error-text"
                  >
                    {i18nmessages.enterZipPostalCode}
                  </FormHelperText>
                )}
              </FormControl>
            </div>

            <FormControl
              className={`${classes.formControl} ${classes.inputMargin}`}
              fullWidth
            >
              <InputLabel
                className={classes.formLabels}
                shrink={true}
                htmlFor={"component-error"}
              >
                {props.checkout.phoneNumberTitle && (
                  <RichTitle titleText={props.checkout.phoneNumberTitle}/>
                )}
              </InputLabel>
              <Input
                className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                id="component-error"
                value={phone}
                onChange={handlePhoneChange}
                aria-describedby="component-error-text"
                fullWidth
                name="phone"
              />
            </FormControl>

            <h2 style={{ marginTop: "23px" }}>{i18nmessages.billingAddress}</h2>
            <RadioGroup
              aria-label={i18nmessages.shippingAsBilling}
              name="Billing Address"
              value={i18nmessages.useShippingAsBilling}
              defaultValue={"true"}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value={"true"}
                control={
                  <Radio
                    classes={{ root: classes.radio, checked: classes.checked }}
                  />
                }
                label={i18nmessages.sameAddrShipping}
              />
              <FormControlLabel
                value={"false"}
                control={
                  <Radio
                    classes={{ root: classes.radio, checked: classes.checked }}
                  />
                }
                label={i18nmessages.useDiffBilling}
              />
            </RadioGroup>

            {useShippingAsBilling === true ? null : (
              <div>
                <FormControl
                  className={`${classes.formControl} ${classes.inputMargin}`}
                  error={billingAddressError}
                  fullWidth
                >
                  <InputLabel
                    className={classes.formLabels}
                    shrink={true}
                    htmlFor={"component-error"}
                  >
                    {props.checkout.addressTitle && (
                      <RichTitle titleText={props.checkout.addressTitle}/>
                    )}
                  </InputLabel>
                  <Input
                    onBlur={() => {
                      if (
                        !/\S/.test(billingAddress) &&
                        useShippingAsBilling === false
                      ) {
                        setBillingAddressError(true)
                      } else {
                        setBillingAddressError(false)
                      }
                    }}
                    className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                    id="component-error"
                    value={billingAddress}
                    onChange={handleBillingAddressChange}
                    aria-describedby="component-error-text"
                  />
                  {billingAddressError && (
                    <FormHelperText
                      id="component-error-text"
                      className={classes.formHelperText}
                    >
                      {i18nmessages.enterAddress}
                    </FormHelperText>
                  )}
                </FormControl>

                <FormControl
                  className={`${classes.formControl} ${classes.inputMargin}`}
                  // error={billingApartmentError}
                  fullWidth
                >
                  <InputLabel
                    className={classes.formLabels}
                    shrink={true}
                    htmlFor={"component-error"}
                  >
                    {props.checkout.apartmentTitle && (
                      <RichTitle titleText={props.checkout.apartmentTitle}/>
                    )}
                  </InputLabel>
                  <Input
                    className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                    id="component-error"
                    value={billingApartment}
                    onChange={handleBillingApartmentChange}
                    aria-describedby="component-error-text"
                  />
                </FormControl>

                <div className={classes.groupContainer}>
                  <FormControl
                    className={`${classes.formControl} ${classes.firstBox}  ${classes.inputMargin}`}
                    error={billingCityError}
                    fullWidth={props.width === "xl" ? false : true}
                  >
                    <InputLabel
                      className={classes.formLabels}
                      shrink={true}
                      htmlFor={"component-error"}
                    >
                      {props.checkout.cityTitle && (
                        <RichTitle titleText={props.checkout.cityTitle}/>
                      )}
                    </InputLabel>
                    <Input
                      onBlur={() => {
                        if (
                          !/\S/.test(billingCity) &&
                          useShippingAsBilling === false
                        ) {
                          setBillingCityError(true)
                        } else {
                          setBillingCityError(false)
                        }
                      }}
                      className={`${classes.formControl} ${classes.boxBorders}`}
                      id="component-error"
                      value={billingCity}
                      onChange={handleBillingCityChange}
                      aria-describedby="component-error-text"
                    />
                    {billingCityError && (
                      <FormHelperText
                        id="component-error-text"
                        className={classes.formHelperText}
                      >
                        {i18nmessages.enterCity}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <FormControl
                    className={`${classes.formControl} ${classes.textBoxContainers}  ${classes.inputMargin}`}
                    // error={billingCountryError}
                    fullWidth={props.width === "xl" ? false : true}
                  >
                    <InputLabel
                      className={`${classes.textBoxContainers} ${classes.formLabels}`}
                      htmlFor={"component-error"}
                      shrink={true}
                    >
                      {props.checkout.countryTitle && (
                        <RichTitle titleText={props.checkout.countryTitle}/>
                      )}
                    </InputLabel>

                    <Input
                      onBlur={() => {
                        if (
                          !/\S/.test(billingCountry) &&
                          useShippingAsBilling === false
                        ) {
                          setBillingCityError(true)
                        } else {
                          setBillingCityError(false)
                        }
                      }}
                      className={`${classes.formControl} ${classes.boxBordersDisabled} ${classes.disabled}`}
                      id="component-error"
                      value={billingCountry}
                      onChange={handleBillingCountryChange}
                      disabled="disabled"
                      aria-describedby="component-error-text"
                    />
                    {/* {billingCountryError && (
                      <FormHelperText
                        id="component-error-text"
                        className={classes.formHelperText}
                      >
                        {i18nmessages.enterCountryRegion}
                      </FormHelperText>
                    )} */}
                  </FormControl>
                </div>

                <div className={classes.groupContainer}>
                  <FormControl
                    className={`${classes.formControl} ${classes.firstBox}  ${classes.inputMargin}`}
                    error={billingProvinceError}
                    fullWidth={props.width === "xl" ? false : true}
                  >
                    <InputLabel
                      className={classes.formLabels}
                      shrink={true}
                      htmlFor={"component-error"}
                    >
                      {props.checkout.provinceTitle && (
                        <RichTitle titleText={props.checkout.provinceTitle}/>
                      )}
                    </InputLabel>
                    <Input
                      onBlur={() => {
                        if (
                          !/\S/.test(billingProvince) &&
                          useShippingAsBilling === false
                        ) {
                          setBillingProvinceError(true)
                        } else {
                          setBillingProvinceError(false)
                        }
                      }}
                      className={`${classes.formControl} ${classes.boxBorders}`}
                      id="component-error"
                      value={billingProvince}
                      onChange={handleBillingProvinceChange}
                      aria-describedby="component-error-text"
                    />
                    {billingProvinceError && (
                      <FormHelperText
                        id="component-error-text"
                        className={classes.formHelperText}
                      >
                        {i18nmessages.enterProvince}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <FormControl
                    className={`${classes.formControl} ${classes.textBoxContainers}  ${classes.inputMargin}`}
                    error={billingPostalCodeError}
                    fullWidth={props.width === "xl" ? false : true}
                  >
                    <InputLabel
                      className={`${classes.textBoxContainers} ${classes.formLabels}`}
                      htmlFor={"component-error"}
                      shrink={true}
                    >
                      {props.checkout.postalCodeTitle && (
                        <RichTitle titleText={props.checkout.postalCodeTitle}/>
                      )}
                    </InputLabel>

                    <Input
                      onBlur={() => {
                        if (
                          !/\S/.test(billingPostalCode) &&
                          useShippingAsBilling === false
                        ) {
                          setBillingPostalCodeError(true)
                        } else {
                          setBillingPostalCodeError(false)
                        }
                      }}
                      className={`${classes.formControl} ${classes.boxBorders}`}
                      id="component-error"
                      value={billingPostalCode}
                      onChange={handleBillingPostalCodeChange}
                      aria-describedby="component-error-text"
                    />
                    {billingPostalCodeError && (
                      <FormHelperText
                        id="component-error-text"
                        className={classes.formHelperText}
                      >
                        {i18nmessages.enterZipPostalCode}
                      </FormHelperText>
                    )}
                  </FormControl>
                </div>
              </div>
            )}
          </div>
        )}

        <div className={classes.buttonSpacing}>
          <Link className={classes.buttonStyling} to="/">
            <Button
              className={classes.desktopButtonShopping}
              color={"transparent"}
              onClick={saveShippingInformation}
            >
              <span>{i18nmessages.continueShopping}</span>
            </Button>
          </Link>

          <Button
            className={`${classes.desktopButton} ${classes.buttonRoot}`}
            color={"green"}
            onClick={handleSubmit}
            disabled={validate()}
          >
            {i18nmessages.continueToPayment}
          </Button>
          <Button
            className={`${classes.mobileButton} ${classes.buttonRoot}`}
            color={"green"}
            onClick={handleSubmit}
            disabled={validate()}
          >
            {i18nmessages.proceed}
          </Button>
        </div>
        {props.width === "lg" || props.width === "xl" ? (
          <div className={classes.paymentsContainer}>
            <span>
              {i18nmessages.securePaymentsBy}{" "}
              <span className={classes.payUStyle}>PayU</span>
            </span>
            <div>
              <img className={classes.paymentLogosPayU} src={payu} alt=""/>
              <img className={classes.paymentLogos} src={visa} alt=""/>
              <img className={classes.paymentLogos} src={master} alt=""/>
              <img className={classes.paymentLogos} src={amex} alt=""/>
              <img className={classes.paymentLogos} src={discover} alt=""/>
            </div>
          </div>
        ) : null}

        {!props.showCart && (
          <footer>
            {props.width === "lg" || props.width === "xl" ? (
              <div className={classes.footerContainer}>
                {props.footer.copyright.titleText && (
                  <RichDescription
                    copyText={props.footer.copyright.titleText}
                  />
                )}
                <Link
                  className={classes.link}
                  to={`/${props.langKey}/terms-of-use`}
                >
                  <span>{i18nmessages.termsOfUse}</span>
                </Link>
              </div>
            ) : (
              <div className={classes.footerContainer}>
                <div className={classes.footerBorderBox}>
                  <Link
                    className={classes.footerTerms}
                    to={`/${props.langKey}/terms-of-use`}
                  >
                    {i18nmessages.termsOfUse}
                  </Link>
                  <Link className={classes.secondTerm} to="/">
                    {i18nmessages.privacyPolicy}
                  </Link>
                </div>
                <span className={classes.brandPadding}>
                  {props.footer.copyright.titleText && (
                    <RichDescription
                      copyText={props.footer.copyright.titleText}
                    />
                  )}
                </span>
              </div>
            )}
          </footer>
        )}
      </div>
      <form
        method="post"
        action="https://checkout.payulatam.com/ppp-web-gateway-payu/"
      >
        <input name="merchantId" type="hidden" value="71746"/>
        <input name="accountId" type="hidden" value="829530"/>
        <input
          name="description"
          type="hidden"
          value="Avicanna payment Gateway"
        />
        <input name="referenceCode" type="hidden" value={refCodeGenerator}/>
        <input name="amount" type="hidden" value={amount}/>
        <input name="tax" type="hidden" value="0"/>
        <input name="taxReturnBase" type="hidden" value="0"/>
        <input name="currency" type="hidden" value={currency}/>
        <input name="signature" type="hidden" value={signature}/>
        <input
          name="buyerFullName"
          type="hidden"
          value={`${name} ${lastName}`}
        />
        {phone && <input name="telephone" type="hidden" value={phone}/>}
        <input
          name="shippingAddress"
          type="hidden"
          value={apartment ? `${apartment}- ${address}` : `${address}`}
        />
        <input name="shippingCity" type="hidden" value={city}/>
        <input name="shippingCountry" type="hidden" value="CO"/>
        <input name="algorithmSignature" type="hidden" value="SHA256"/>
        <input name="payerDocument" type="hidden" value={ID}/>
        <input name="test" type="hidden" value="0"/>
        <input name="buyerEmail" type="hidden" value={email}/>
        {order.data && (
          <input name="extra1" type="hidden" value={order.data.id}/>
        )}
        <input name="extra2" type="hidden" value={access_token}/>
        <input
          name="responseUrl"
          type="hidden"
          value="https://www.puraearth.com/paymentConfirmation/"
        />
        <input
          name="confirmationUrl"
          type="hidden"
          value="https://r2jf5mnlu7.execute-api.sa-east-1.amazonaws.com/dev/PayU/post-route"
        />
        <button
          name="submit"
          ref={props.reference}
          value="submit"
          className={classes.hiddenButton}
        />
      </form>
    </div>
  )
}

export default withWidth()(injectIntl(ShippingInformation))
